import { useEffect, useRef, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import Celebration from '@/assets/images/svg/celebration.svg';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';
import { useLessons } from '@/packages/corporate-university/context/lessons';
import { useGenerateCertificate } from '@/packages/corporate-university/hooks';

export const CompletedCourseDialog = () => {
  const { course, isCourseCompleted } = useLessons();
  const { viewCertificate, loadingCertificate } = useGenerateCertificate(
    course?.id ?? ''
  );
  const previousIsCompletedRef = useRef<boolean | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
    previousIsCompletedRef.current = null;
  }, [course?.id]);

  useEffect(() => {
    if (typeof isCourseCompleted !== 'boolean') return;

    if (previousIsCompletedRef.current === null) {
      previousIsCompletedRef.current = isCourseCompleted;
      return;
    }

    if (!previousIsCompletedRef.current && isCourseCompleted) {
      setOpen(true);
    }

    previousIsCompletedRef.current = isCourseCompleted;
  }, [isCourseCompleted]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ConfirmDialog
      onClose={handleClose}
      onConfirm={viewCertificate}
      open={open}
      disableConfirmButton={loadingCertificate}
      actionLabels={{
        confirm: loadingCertificate
          ? 'Gerando certificado...'
          : 'Acessar certificado',
        cancel: 'Fechar',
      }}
    >
      <Box component="img" src={Celebration} sx={{ height: 60, width: 60 }} />
      <Stack gap={1} mt={3}>
        <Typography variant="h2">Curso concluído com sucesso!</Typography>
        <Typography>
          Você concluiu o curso {course?.name}. Acesse seu certificado e celebre
          compartilhando sua nova conquista!
        </Typography>
      </Stack>
    </ConfirmDialog>
  );
};
